<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-card flat class="rounded-0">

      <v-container class="d-flex pl-2 pr-4 py-2">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-btn v-if="closable" color="close" class="mr-2" icon @click="close()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col :cols="0" :class="!closable ? 'mx-3' : 'mr-4'">
            <v-text-field v-model="listfilter" single-line dense clearable hide-details
              :label="$t('servicesystem.common_objects.commonterms.filter')" />
          </v-col>
          <v-col cols="auto" v-if="newable" class="d-flex justify-end align-center">
            <v-btn @click="createnew()" small color="primary">
              <v-icon size="17" class="mr-1">mdi-plus</v-icon>{{ $t('servicesystem.common_objects.commonterms.new') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <QScroll :height="listheight" :list="filteredList" :loading="loading" :skeletonloading="true">

        <template slot="list-item" slot-scope="{ item }">
          <v-list-item v-if="!showdetails" @click="select(item)" :class="IsActive(item) ? '' : 'deletedcolor'">
            <v-list-item-icon class="my-auto">
              <v-icon v-text="IsActive(item) ? 'mdi-map-marker' : 'mdi-map-marker-off'"
                :color="IsActive(item) ? '' : 'disabled'" />
            </v-list-item-icon>
            <v-list-item-content class="py-0">
              <v-list-item-title v-text="item.Name" :class="IsActive(item) ? 'useThemeTextColor' : ''" />
            </v-list-item-content>
            <v-list-item-action v-if="isTheSameAddress(Selected, item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-list-item-action>
            <v-list-item-action v-if="addressIdIsFromErp(item.Id)" class="disabled--text">
              {{ ERPFriendlyName }}
            </v-list-item-action>
          </v-list-item>

          <v-hover v-slot="{ hover }" v-else>
            <AddressTemplate :Address="item">
              <template v-slot:action-buttons>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-if="AllowChangeAddress" v-bind="attrs" v-on="on" icon
                      @click="addressIdIsFromErp(item.Id) ? null : $emit('Edit', item)">
                      <v-icon v-show="hover" :color="addressIdIsFromErp(item.Id) ? 'disabled' : ''">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ addressIdIsFromErp(item.Id) ? $t("servicesystem.text.from_erp_locked in_ss", {
                    ekey:
                      ERPFriendlyName
                  }) : $t("servicesystem.text.edit") }}</span>
                </v-tooltip>
              </template>
            </AddressTemplate>
          </v-hover>
        </template>

        <template slot="skeleton-loader">
          <v-skeleton-loader type="list-item-avatar" class="address">
          </v-skeleton-loader>
        </template>

      </QScroll>
    </v-card>
  </v-container>
</template>


<script>
import Vue from "vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import QScroll from "@/components/Sections/Containers/QScroll.vue";
import AddressTemplate from "@/components/Preview/Customer/AddressTemplate.vue";

export default {
  name: "AddressList",
  props: {
    CustomerId: [String, Number],
    Selected: [String, Number, Object],
    closable: {
      default: true,
      type: Boolean,
    },
    showdetails: Boolean,
    listheight: {
      default: 300,
      type: Number,
    },
  },
  components: {
    QScroll,
    AddressTemplate,
  },
  mixins: [clientAPI],

  data: () => ({
    list: [],
    listfilter: null,
    loading: false,
  }),

  mounted() {
    this.getAddresses();
  },

  methods: {
    getAddresses() {
      if (this.CustomerId) {
        this.loading = true;
        this.getCustomerAdressesByCustomerId(this.CustomerId)
          .then((response) => {
            this.list = response;
            this.$emit("EmitList", response);
            //console.log(response);
          })
          .catch((response) => {
            console.error("getAddresses error", response);
          })
          .finally(() => {
            this.loading = false;
          });
        /*
        if (!this.Selected) {
          this.SelectDefault();
        }
        */
      }
    },

    SelectDefault() {
      this.select(this.list[0]);
    },

    close() {
      this.$emit("Close");
    },

    isTheSameAddress(a, b) {
      if (!a || !b) {
        return false;
      }
      if (a.Id === b.Id) {
        return true;
      }
      else if ((a.Street == b.Street) && (a.Zip == b.Zip) && (a.City == b.City) && (a.Country == b.Country)) {
        return true;
      }
      else {
        return false;
      }
    },

    select(item) {
      if (this.isTheSameAddress(this.Selected, item)) {
        this.close();
      }
      else {
        this.$emit("Select", item);
      }
    },

    createnew() {
      this.$emit("New");
    },

    IsActive(item) {
      return item.IsActive !== false;
    },

    updateItem(item) {
      var index = this.list.findIndex((x) => x.Id == item.Id);
      if (index < 0) {
        index = this.list.length;
      }
      Vue.set(this.list, index, item);
    },
  },

  computed: {
    filteredList() {
      if (this.listfilter) {
        return this.list.filter((v) =>
          v && v.MetaString ? v.MetaString.toUpperCase().includes(this.listfilter.toUpperCase()) : null
        );
      } else {
        return this.list;
      }
    },

    newable() {
      return !this.CustomerAddressReadonly && this.checkPermission("Actions", "createCustomerAddress");
    },

    AllowChangeAddress() {
      return !this.CustomerAddressReadonly && this.checkPermission("Actions", "editCustomerAddress");
    },
  },

  watch: {
    CustomerId: function () {
      this.getAddresses();
    },
  },
};
</script>


<style lang="scss">
.v-skeleton-loader.address .v-skeleton-loader__list-item-avatar {
  height: 40px !important;
}

.v-skeleton-loader.address .v-skeleton-loader__list-item-avatar .v-skeleton-loader__avatar {
  height: 25px !important;
  width: 25px !important;
}
</style>